export const EQ_TYP = {
  bt_inverter: 'Battery_Inverters',
  pv_inverter: 'Solar_Inverters',
  hybrid_inverter: 'Hybrid',
  ess: 'ESS',
  battery: 'Batteries',
  solar: 'PV',
  pcs: 'PCSData',
};

export const contactType = {
  customer: 'Customer',
  applicant: 'Applicant',
  installer: 'Installer',
  aggregator: 'Aggregator',
  service:'service',
  derOwner:'derOwner',
  secCust:'secCust',
  poiOwner:'poiOwner',
  insElect:'insElect'
};

export const docType = {
  SiteDiagrams: 'SiteDiagrams',
  ElecOneLnDraw: 'ElectricOneLineDrawings',
  preInstallPics: 'PreInstallationSitePictures',
  InvSpec: 'InverterSpecifications',
  GenSpec: 'GeneratorSpecifications',
  HomeLbIns: 'HomeOwnersLiabilityInsurance',
  others: 'Miscellaneous',
};

export const docTypeList = {
  SiteDiagrams: 'Site Diagrams',
  ElectricOneLineDrawings: 'Electric Oneline Drawings',
  PreInstallationSitePictures: 'Pre Installation Site Pictures',
  //InstallationDrawings:'Installation Drawings',
  InverterSpecifications: 'Inverter Specifications',
  GeneratorSpecifications: 'Generator Specifications',
  HomeOwnersLiabilityInsurance: 'Home Owners Liability Insurance',
  Miscellaneous: 'Miscellaneous',
};

export const docTypeIds = {
  SiteDiagrams: 'DOC_SITE_DGRM',
  ElectricOneLineDrawings: 'DOC_ELTRC_1LN_DGRM',
  PreInstallationSitePictures: 'CAS_SITE_PRE_1_PIC',
  InverterSpecifications: 'INVT_A_SPEC_SHEET',
  GeneratorSpecifications: 'GEN_A_SPEC_DOC',
  HomeOwnersLiabilityInsurance: 'DOC_PROOF_OF_INSRC',
  Miscellaneous: 'AEP_ADD_MISC_1_DOC',
};

export const appType = {
  PREAPP: 'PreApplication',
  ICX: 'Interconnect',
  DR: 'DemandResponse',
  AGG: 'AggregatiorRegistration',
};

export const programList = [
  { option: 'Net Metering', value: 'Net_Metering' },
  { option: 'Buy All-Sell All', value: 'BuyAll_SellAll' },
  { option: 'Aggregator', value: 'Aggregator' },
  { option: 'Capacity', value: 'Capacity' },
];

const OPCO_CD ={
  AEP_OH: 'AEP Ohio',
  AEP_TX: 'AEP Texas',
  APCO:'Appalachian Power',
  KTY:'Kentucky Power',
  IMP:'Indiana & Michigan Power',
  PSO:'Public Service Co. of Oklahoma',
  SOWEP:'Southwestern Electric Power'
}

export const opcoList = [
  { option: 'AEP Ohio', value: 'AEP Ohio' },
  { option: 'AEP Texas', value: 'AEP Texas' },
  { option: 'Appalachian Power', value: 'Appalachian Power' },
  { option: 'Indiana & Michigan Power', value: 'Indiana & Michigan Power' },
  { option: 'Kentucky Power', value: 'Kentucky Power' },
  {
    option: 'Public Service Co. of Oklahoma',
    value: 'Public Service Co. of Oklahoma',
  },
  {
    option: 'Southwestern Electric Power',
    value: 'Southwestern Electric Power',
  },
];

export const opcoRef = {
  [OPCO_CD.AEP_OH]: 'AEP Ohio',
  [OPCO_CD.AEP_TX]: 'AEP Texas',
  [OPCO_CD.APCO]:'APCO',
  [OPCO_CD.IMP]:'Indiana Michigan',
  [OPCO_CD.KTY]:'Kentucky',
  [OPCO_CD.PSO]:'PSO',
  [OPCO_CD.SOWEP]:'SWEPCO',
}

export const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const DERSystemDevice = [
  {
    option: 'Variable Load Devices',
    value: 'Variable Load Devices',
    eType: null,
  },
  {
    option: 'Energy Storage Devices',
    value: 'Energy Storage Devices',
    eType: [
      { option: 'Electrical', value: 'Electrical' ,esd:['Battery/EV','Flywheel','Pumped Hydro']},
      { option: 'Thermal', value: 'thermal', esd:null},
    ],
  },
  {
    option: 'Generation Devices',
    value: 'Generation Devices',
    eType: [
      { option: 'Inverter Based Resource', value: 'Inverter Based Resource',esd:['Solar PV','Wind','Fuel Cell','Micro-Turbine','Other'] },
      { option: 'Induction', value: 'Induction',esd:[,'Wind','Hydro','Other']  },
      { option: 'Synchronous', value: 'Synchronous',esd:[,'Natural Gas','Coal','Hydro','Wind','Fuel Oil','Waste','Other'] },
    ],
  },
];

export const pattern = {
  email:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  phone: /^[(]?\d{3}[)]?[(\s)?.-]\d{3}[\s.-]\d{4}$/,
  lat:/^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/,
  longi:/^[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/
};

export const allowOnlyNumbers = (value) => {
  return value.replace(/[^0-9]/g, '');
};

export const allowDecimalNumbers = (value) => {
  var re = /^-?\d*\.?\d{0,12}$/; 
  return value.match(re, '');
};

export const optionMapper = (list, key) =>
  list?.map((el) => (
    <option value={key ? el[key] : el}>{key ? el[key] : el}</option>
  ));

export const optionValueMapper = (list) =>
  list.map((el) => <option value={el?.value}>{el?.option}</option>);

export const isAEPLat = num => !isNaN(num) && (num > 25.70 && num  <= 42.70);
export const isAEPLongi = num => !isNaN(num) && (num > -106.0 && num <= -77.50);


